var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pageBox" },
        [
          _c(
            "div",
            { staticClass: "breadcrumb" },
            [
              _c(
                "el-breadcrumb",
                { attrs: { separator: "/" } },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v("首页"),
                  ]),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v("任务管理")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pageSerch" },
            [
              _c(
                "el-card",
                { staticClass: "box-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", { staticClass: "cardTitle" }, [
                        _vm._v("违约列表"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "姓名" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "50",
                                      clearable: "",
                                      placeholder: "请输入违约人姓名",
                                    },
                                    model: {
                                      value: _vm.ruleForm.memberName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "memberName",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.memberName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "手机号" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "50",
                                      clearable: "",
                                      placeholder: "请输入违约人手机号",
                                    },
                                    model: {
                                      value: _vm.ruleForm.memberPhone,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "memberPhone",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.memberPhone",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "违约编号" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "50",
                                      clearable: "",
                                      placeholder: "请输入违约编号",
                                    },
                                    model: {
                                      value: _vm.ruleForm.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "name", $$v)
                                      },
                                      expression: "ruleForm.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "任务编号" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "50",
                                      clearable: "",
                                      placeholder: "请输入任务编号",
                                    },
                                    model: {
                                      value: _vm.ruleForm.jobNo,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "jobNo", $$v)
                                      },
                                      expression: "ruleForm.jobNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "支付状态" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { "margin-right": "auto" },
                                      attrs: { placeholder: "请选择支付状态" },
                                      model: {
                                        value: _vm.ruleForm.cadeVerifyStatus,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "cadeVerifyStatus",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.cadeVerifyStatus",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "待支付", value: "0" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "已支付", value: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "违约人类型" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { "margin-right": "auto" },
                                      attrs: {
                                        placeholder: "请选择违约人类型",
                                      },
                                      model: {
                                        value: _vm.ruleForm.memberType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "memberType",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.memberType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "客户", value: "1" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "临勤", value: "3" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: "保安公司",
                                          value: "4",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: {
                                          label: "保安公司员工",
                                          value: "5",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "btn",
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.getList()
                                        },
                                      },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.resetForm()
                                        },
                                      },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("TableScrollSlider", {
            attrs: { "table-ref": _vm.$refs.scrollTable },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pageTab" },
            [
              _c(
                "el-table",
                {
                  ref: "scrollTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableData },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "violateLogNo",
                      label: "单号",
                      align: "center",
                      width: "190",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jobNo",
                      label: "任务编号",
                      align: "center",
                      width: "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jobTitle",
                      label: "任务名称",
                      align: "center",
                      width: "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "memberName",
                      label: "违约人",
                      align: "center",
                      width: "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "120",
                      prop: "memberPhone",
                      label: "违约人手机号",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "违约人类型",
                      align: "center",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.memberType == 0
                              ? _c("span", [_vm._v("所有用户")])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.memberType == 1
                              ? _c("span", [_vm._v("客户")])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.memberType == 2
                              ? _c("span", [_vm._v("保安")])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.memberType == 3
                              ? _c("span", [_vm._v("临勤")])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.memberType == 4
                              ? _c("span", [_vm._v("保安公司")])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.memberType == 5
                              ? _c("span", [_vm._v("保安公司员工")])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "matterMemo",
                      label: "违约事项",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "违约时间", align: "center", width: "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.violateAt))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "触发规则", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.withholdType == 2
                              ? _c("span", [_vm._v("￥")])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(scope.row.withholdNum))]),
                            _vm._v(" "),
                            scope.row.withholdType == 1
                              ? _c("span", [_vm._v("%")])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "违约金额", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                "￥" +
                                  _vm._s(
                                    _vm._f("moneyFormat")(
                                      scope.row.actualPayAmount
                                    )
                                  )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "违约状态", align: "center", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.status == 0
                              ? _c("span", { staticClass: "blueColor" }, [
                                  _vm._v("待支付"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.status == 1
                              ? _c("span", { staticClass: "greenColor" }, [
                                  _vm._v("已支付"),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center", fixed: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "disAround" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "operateBtn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.goDetail(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("查看")]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.pageSize,
                  layout: "total, prev, pager, next,sizes",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }